import {defineStore, type StoreDefinition} from "pinia";
import {type DialogStoreState, state} from "@/store/dialog/state";
import {type DialogStoreActions, actions} from "@/store/dialog/actions";

export type DialogStoreType = StoreDefinition<string, DialogStoreState, any, DialogStoreActions>;

export const useDialogStore: DialogStoreType = defineStore('dialogStore', {
    state,
    actions
});
